import { render, staticRenderFns } from "./page-thankyou.vue?vue&type=template&id=40c00654&"
import script from "./page-thankyou.vue?vue&type=script&lang=js&"
export * from "./page-thankyou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports